import { useToast } from '@/composables/useToast.js';

export default {
  install(app) {
    const toast = useToast();
    
    // Make available as this.$toast in Options API components
    app.config.globalProperties.$toast = toast;
    
    // Make available as app.config.globalProperties.$toast for programmatic access
    app.provide('toast', toast);
  }
}; 